module.exports = __webpack_public_path__ + "static/java-a46aaaca8b72920b2699b47687470f1c.png";